<rask-container-block>
    <ng-container header>EUDR Anmälan</ng-container>
    <rask-row class="mb-3">
        <div class="col-md-12">
            <rask-input
                [(ngModel)]="beteckning"
                label="Arbetsorder beteckning"
                placeholder="Ange arbetsorder beteckning">
            </rask-input>
            <rask-button
                (click)="getArbetsorder()"
                color="secondary"
                [disabled]="disableFetchArbetsorder">
                Hämta arbetsorder
            </rask-button>
        </div>
    </rask-row>

    @if (hamtadArbetsorder) {
        <rask-cards>
            <rask-card label="Hämtad arbetsorder" [size]="4">
                <ng-container>
                    <p><strong>Beteckning:</strong> {{hamtadArbetsorder.beteckning}}</p>
                    <p><strong>Namn:</strong> {{hamtadArbetsorder.namn}}</p>
                </ng-container>
            </rask-card>
        </rask-cards>
    }

    <div class="mt-3">
        <rask-button
            (click)="onSubmitClick()"
            color="primary"
            [disabled]="disableSubmit">
            Skicka ny
        </rask-button>
        <rask-button
            (click)="onAmendClick()"
            color="primary"
            [disabled]="disableAmend">
            Uppdatera
        </rask-button>
        <rask-button
            (click)="onRemoveClick()"
            color="primary"
            [disabled]="disableRetract">
            Återkalla
        </rask-button>
    </div>

    @if (hamtadArbetsorder) {
        <div class="mt-3">
            <rask-checkbox
                text="EUDR status krävs ej"
                [(ngModel)]="hamtadArbetsorder.ejEudr"
                (ngModelChange)="setEjEudr($event)">
            </rask-checkbox>
        </div>
        <rask-button class="mt-2" aid="buttonSpara" raskHotkey="ctrl+s" color="primary" [disabled]="!canSave()" (click)="saveChanges()">Spara</rask-button>
    }

     @if ((eudrAnmalan$ | async)?.items.length > 0) {
        <rask-toggle-panel class="mt-3" label="Historik">
            <rask-list [data]="$safeNavigationMigration((eudrAnmalan$ | async)?.items)">
                <rask-list-column header="ReferensNr" field="referens"></rask-list-column>
                <rask-list-column header="VerifieringsNr" field="verifiering"></rask-list-column>
                <rask-list-column header="Status" field="status">
                    <ng-template let-row="row">
                        {{row.status}}
                        @if(row.errors?.length > 0){
                            <rask-icon
                                popoverClass="popover-error popover-no-max-width"
                                icon="error fal fa-info-circle">
                                <div class="popover-message-container">
                                    @for(error of row.errors; track error){
                                        <div class="popover-message" #message>
                                            {{error}}
                                        </div>
                                    }
                                </div>
                            </rask-icon>
                        }
                    </ng-template>
                </rask-list-column>
                <rask-list-column header="skickad" field="skickad">
                    <ng-template let-row="row">
                        {{row.skickad | date: 'yyyy-MM-dd' }}
                    </ng-template>
                </rask-list-column>
                <rask-list-column header="Kvitterad" field="kvitterad">
                    <ng-template let-row="row">
                        {{row.kvitterad | date: 'yyyy-MM-dd' }}
                    </ng-template>
                </rask-list-column>
            </rask-list>
        </rask-toggle-panel>
     }
</rask-container-block>

<rask-container-block>
    <ng-container header>Hämta anmälan</ng-container>
    <rask-input label="Referensnummer" [(ngModel)]="referenceNumber"></rask-input>
    <rask-input label="Verifieringsnummer" [(ngModel)]="verificationNumber"></rask-input>
    <rask-button color="secondary" (click)="getStatementByIdentifiers()">Hämta</rask-button>
    <br>
    <rask-textarea class="col-12" label="Resultat" [rows]="45" [(ngModel)]="resultat"></rask-textarea>
</rask-container-block>
